import React from 'react';
import UserModule from '../Users/UserModule';
import { useAuth } from '../../AuthContext';
import StaffProfile from '../Faculty/StaffProfile';
import CircularProgress from '@mui/material/CircularProgress';

function Staff({ orgId }) {
  const { userRole, user, loading } = useAuth();

  // If the user is a staff member, show their own profile directly
  if (userRole === 'STAFF') {
    if (loading) {
      return (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <CircularProgress />
        </div>
      );
    }
    if (!user) {
      return (
        <div style={{ padding: 20, color: 'red' }}>
          Profile not found
        </div>
      );
    }
    return (
      <div style={{ padding: 10 }}>
        <StaffProfile selectedUser={user} />
      </div>
    );
  }

  // Otherwise, show the full user management module
  return <UserModule userType="STAFF" orgId={orgId} />;
}

export default Staff;